import { render, staticRenderFns } from "./PaymentLink.vue?vue&type=template&id=5fd94b25&scoped=true"
import script from "./PaymentLink.vue?vue&type=script&lang=js"
export * from "./PaymentLink.vue?vue&type=script&lang=js"
import style0 from "./PaymentLink.vue?vue&type=style&index=0&id=5fd94b25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd94b25",
  null
  
)

export default component.exports